import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Grid,
  Theme,
  Typography,
} from '@material-ui/core';

import { EnvelopeIcon } from '../../components/icon/solid';
import { Link, PagesTitle, Button } from '../../components';
import { useTitle } from '../../hooks';
import PageContainer from './PageContainer';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.menuAction.selected,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
    marginBottom: '42px',

    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  },
  button: {
    minWidth: '189px',
    borderRadius: '5px',
    backgroundColor: palette.menuAction.selected,
    color: palette.common.white,
    fontFamily: 'Montserrat',
    fontSize: '16px',
    textTransform: 'none',
    marginBottom: '42px',
    '&:hover': {
      backgroundColor: palette.menuAction.selected,
    },
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}), { name: 'Register' });

const EmailConfirmed = () => {
  const classes = useStyles();

  useTitle('Email Confirmed');

  return (
    <PageContainer>
      <Grid container className={classes.root}>
        <EnvelopeIcon className={classes.icon} />
        <PagesTitle className={classes.title}>Email confirmed!</PagesTitle>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>Your email address has been confirmed.</p>
          <p>You’re all set to log in to PitchHub!</p>
        </Typography>
        <Link to="/pages/login" className={classes.buttonLink}>
          <Button className={classes.button}>
            Log In
          </Button>
        </Link>
      </Grid>
    </PageContainer>
  );
};

export default EmailConfirmed;
